module.exports = __webpack_public_path__ + "img/circle.b571fb75.png";